import { listenerMiddleware } from '@/reducers/listeners';
import { configureStore } from '@reduxjs/toolkit';
import { createReduxEnhancer as createSentryReduxEnhancer } from '@sentry/react';
import { reducer, State } from '../reducers';

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(
      // Sentry redux breadcrumbs
      createSentryReduxEnhancer({
        // By default, we'll only send the action types
        actionTransformer: (action) => ({ type: action.type }),
        // And no state
        stateTransformer: () => null,
        // But we'll configure the user automatically
        configureScopeWithState: (scope, state: State) => null,
      })
    ),
});

export type AppDispatch = typeof store.dispatch;
export type { State } from '../reducers';
